import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    data() {
        return {
            loadingInductionEvents: false,
            inductionEvents: [],
            loadingTimetableEvents: false,
            timetableEvents: [],
            loadingTimetableEvent: false,
            timetableEvent: {},
        }
    },
    methods: {
        ...mapActions({
            FetchInductionEventsByCourseCode: 'enterpriseDataApi/FetchInductionEventsByCourseCode',
            FetchInductionEventsByCourseCodes: 'enterpriseDataApi/FetchInductionEventsByCourseCodes',
            FetchTimetableEventsByCourseCode: 'enterpriseDataApi/FetchTimetableEventsByCourseCode',
            FetchTimetableEventsByCourseCodes: 'enterpriseDataApi/FetchTimetableEventsByCourseCodes',
            FetchFirstTimetableEventByCourseCode: 'enterpriseDataApi/FetchFirstTimetableEventByCourseCode',
        }),
        LoadInductionEvents(courseCode) {
            this.loadingInductionEvents = true;
            this.FetchInductionEventsByCourseCode({ CourseCode: courseCode })
                .then(response => {
                    this.inductionEvents = Object.assign([], response);
                    eventBus.$emit('induction-events-fetch:success');
                })
                //.catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingInductionEvents = false);
        },
        LoadTimetableEvents(courseCode) {
            this.loadingTimetableEvents = true;
            this.FetchTimetableEventsByCourseCode({ CourseCode: courseCode })
                .then(response => {
                    this.timetableEvents = Object.assign([], response);
                    eventBus.$emit('timetable-events-fetch:success');
                })
                //.catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingTimetableEvents = false);
        },
        LoadInductionEventsByCourseCodes(courseCodes) {
            this.loadingInductionEvents = true;
            this.FetchInductionEventsByCourseCodes({ CourseCodes: courseCodes })
                .then(response => {
                    this.inductionEvents = Object.assign([], response);
                    eventBus.$emit('induction-events-fetch:success');
                })
                //.catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingInductionEvents = false);
        },
        LoadTimetableEventsByCourseCodes(courseCodes) {
            this.loadingTimetableEvents = true;
            this.FetchTimetableEventsByCourseCodes({ CourseCodes: courseCodes })
                .then(response => {
                    this.timetableEvents = Object.assign([], response);
                    eventBus.$emit('timetable-events-fetch:success');
                })
                //.catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingTimetableEvents = false);
        },
        LoadFirstTimetableEvent(courseCode) {
            this.loadingTimetableEvent = true;
            this.FetchFirstTimetableEventByCourseCode({ CourseCode: courseCode })
                .then(response => {
                    this.timetableEvent = Object.assign({}, response);
                    eventBus.$emit('timetable-event-fetch:success');
                })
                //.catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingTimetableEvent = false);
        },
        HasInductionEvents(courseCode) { return this.inductionEvents.filter(te => te.GroupCode == courseCode).length > 0; },
        HasTimetableEvents(courseCode) { return this.timetableEvents.filter(te => te.GroupCode == courseCode).length > 0; },
        Location(event) {
            let location = '';
            if (event.Campus && event.Campus.length > 0) location += event.Campus;
            if (event.RoomNames && event.RoomNames.length > 0) {
                if (location.length > 0) location += ', ';
                location += `room(s): ${event.RoomNames}`;
            }
            return location;
        },
        Staff(event) { return event?.StaffNames || ''; },
        Notes(event) { return event?.Notes || ''; },
  }
};